/* XtremeSkins thumbnail-to-variant sync, 2026-10-26.
 * Uses explicit Shopify media assignments. Native variant code remains responsible
 * for price, availability, URL, hidden variant IDs and basket readiness.
 */
(function () {
  'use strict';
  if (window.__xsThumbnailSyncInstalled) return;
  window.__xsThumbnailSyncInstalled = true;
  const normalise = value => String(value || '').trim().toLowerCase().replace(/\s+/g, '_');

  function optionGroups(picker) {
    // Native picker order is product option order. Custom material controls are outside it.
    return Array.from(picker.querySelectorAll('select, fieldset'))
      .filter(el => el.tagName === 'SELECT' || el.querySelector('input[type="radio"]'))
      .map(el => el.tagName === 'SELECT'
        ? { el, value: el.value, choices: Array.from(el.options) }
        : { el, value: el.querySelector('input:checked')?.value,
            choices: Array.from(el.querySelectorAll('input[type="radio"]')) });
  }

  function chooseVariant(candidates, groups, scope) {
    const exact = candidates.find(v => v.options.every((value, i) => value === groups[i].value));
    if (exact) return exact;
    // A shared Custom template image must not choose a different set of paid sections.
    if (candidates.every(v => v.options.some(value => normalise(value) === 'custom'))) {
      const types = Array.from(scope.querySelectorAll('#CustomizationViews .material-select'))
        .map(select => select.selectedOptions[0]?.dataset.type)
        .filter(type => type && type !== 'unselected').map(normalise);
      if (scope.querySelector('#GelSelect')?.checked) types.push('gel');
      const matches = candidates.filter(v => {
        const parts = v.options.filter(value => normalise(value) !== 'custom')
          .flatMap(value => value.split('+').map(normalise));
        return parts.length === types.length && parts.every(type => types.includes(type));
      });
      return matches.length === 1 ? matches[0] : null;
    }
    const ranked = candidates.map(variant => ({ variant,
      score: variant.options.reduce((score, value, i) => score + (value === groups[i].value ? 1 : 0), 0)
    })).sort((a, b) => b.score - a.score);
    // No guessing when an image is assigned to equally plausible different configurations.
    return ranked.length === 1 || ranked[0].score > ranked[1].score ? ranked[0].variant : null;
  }

  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button > 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const button = event.target.closest?.('button.thumbnail');
    const gallery = button?.closest('media-gallery');
    const thumbnail = button?.closest('[data-target]');
    const strip = button?.closest('[id^="GalleryThumbnails-"]');
    if (!gallery || !thumbnail || !strip || !gallery.contains(strip)) return;
    const sectionId = gallery.id.replace(/^MediaGallery-/, '');
    const scope = gallery.closest('.shopify-section');
    if (!sectionId || !scope) return;
    const maps = Array.from(scope.querySelectorAll('script[data-xs-thumbnail-map]'))
      .filter(el => el.dataset.xsThumbnailMap === sectionId);
    const pickers = Array.from(scope.querySelectorAll('variant-selects'))
      .filter(el => el.dataset.section === sectionId || el.id === `variant-select-${sectionId}`);
    if (maps.length !== 1 || pickers.length !== 1) return;
    const picker = pickers[0];
    // Do not trigger selection before the native change handler has been registered.
    if (!customElements.get('variant-selects') || !picker.matches(':defined')) return;
    const mediaPrefix = sectionId + '-';
    if (!thumbnail.dataset.target.startsWith(mediaPrefix)) return;
    const mediaId = thumbnail.dataset.target.slice(mediaPrefix.length);
    try {
      const variants = JSON.parse(maps[0].textContent);
      if (!Array.isArray(variants)) return;
      const groups = optionGroups(picker);
      if (!groups.length) return;
      const candidates = variants.filter(v => String(v.mediaId) === mediaId &&
        Array.isArray(v.options) && v.options.length === groups.length);
      if (!candidates.length) return; // Lifestyle photos, videos and other unassigned media are preview-only.
      const variant = chooseVariant(candidates, groups, scope);
      if (!variant) return;
      const changes = groups.map((group, i) => ({ group,
        choice: group.choices.find(choice => choice.value === variant.options[i])
      }));
      if (changes.some(({ group, choice }) => !choice || group.el.disabled || choice.disabled)) return;
      const changed = changes.filter(({ group, choice }) => group.value !== choice.value);
      if (!changed.length) return;
      // Set all option axes before emitting ONE event; the native fetch must see a complete combination.
      changes.forEach(({ group, choice }) => {
        if (group.el.tagName === 'SELECT') {
          group.el.value = choice.value;
          group.choices.forEach(option => option.toggleAttribute('selected', option === choice));
          if (typeof picker.updateSelectionMetadata === 'function') {
            picker.updateSelectionMetadata({ target: group.el });
          }
        } else {
          choice.checked = true;
          const label = Array.from(picker.querySelectorAll('[data-selected-value]'))
            .find(el => el.dataset.selectedValue === choice.name);
          if (label) label.textContent = choice.value;
        }
      });
      const last = changed[changed.length - 1];
      const target = last.group.el.tagName === 'SELECT' ? last.group.el : last.choice;
      target.dispatchEvent(new Event('change', { bubbles: true }));
    } catch (error) {
      // Leave the image gallery usable; never fabricate a product or a finish on malformed data.
      console.warn('[XtremeSkins] Thumbnail selection could not be synchronised.', error);
    }
  });
})();
